import React from 'react';
import { useAppConfigContext, useAssignedAppTypeContext } from '@vivli/core/infrastructure/context';

export const OrgResourcesLinkComponent = () => {
    const { isAmr } = useAssignedAppTypeContext();
    const config = useAppConfigContext();
    const orgAdminLink = isAmr ? config.amrOrganizationAdminResourcesLink : config.vivliOrganizationAdminResourcesLink;

    return (
        <div
            style={{
                textAlign: 'right',
                marginRight: '40px',
            }}
        >
            <a href={orgAdminLink} target="_blank">
                Organization Administrator Resources
            </a>
        </div>
    );
};
